module.exports = __webpack_public_path__ + "static/media/terminated-status.0c3b6724.svg";